export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/logo.png"
    alt="IGL — Improvisational Guitar Lab"
    className={`${className} rounded-lg object-cover ring-1 ring-blue-500/30 shadow-[0_0_16px_rgba(59,130,246,0.35)]`}
  />
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="igl-logo">
    <LogoMark className="h-10 w-10 shrink-0" />
    <div className="leading-none">
      <span className="font-serif text-2xl font-semibold tracking-tight text-slate-100">IGL</span>
      {!compact && (
        <span className="block pt-1 font-mono text-[9px] uppercase tracking-[0.28em] text-blue-400/70">
          Improvisational Guitar Lab
        </span>
      )}
    </div>
  </div>
);
